var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { primaryColor } from '../../../../Utils/utilsStyle';
var SVG = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n&:hover {\n  path {\n    fill: ", ";\n    stroke: ", ";\n  }\n}\n"], ["\n&:hover {\n  path {\n    fill: ", ";\n    stroke: ", ";\n  }\n}\n"])), primaryColor, primaryColor);
var defaultProps = {
    onClick: function () { },
    fillColor: '#001760',
};
var PlusIconSvg = function PlusIconSvg(props) {
    var onClick = props.onClick, className = props.className, fillColor = props.fillColor;
    var handleClick = function (event) {
        event.stopPropagation();
        if (onClick) {
            onClick();
        }
    };
    return (_jsxs(SVG, __assign({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "16", viewBox: "0 0 15 16", fill: "none", onClick: handleClick, className: className }, { children: [_jsx("path", { d: "M6.63136 14.7402V14.9246H6.81572H7.98234H8.16669V14.7402V8.54705H13.958H14.1424V8.36269V7.27384V7.08949H13.958H8.16669V1V0.815645H7.98234H6.81572H6.63136V1V7.08949H1.02148H0.837129V7.27384V8.36269V8.54705H1.02148H6.63136V14.7402Z", fill: fillColor, stroke: fillColor, strokeWidth: "0.368711" }), " "] })));
};
PlusIconSvg.defaultProps = defaultProps;
export default PlusIconSvg;
var templateObject_1;
